<script setup lang="ts">
import { computed } from 'vue';

import IconStarRatingOutlined from '@/shared/components/UI/Icons/IconStarRatingOutlined.vue';
import IconStarRatingSolid from '@/shared/components/UI/Icons/IconStarRatingSolid.vue';
import { useTranslations } from '@/shared/composables/useTranslations';
const { t } = useTranslations();
const { rating } = defineProps<{
  rating: number;
}>();

const fragmentStar = computed(() => rating % 1);
const fullStars = computed(() => Math.floor(rating));
const outlinedStars = computed(() => 5 - Math.ceil(rating));

const mask = computed(() => {
  // Optical adjustment of the mask so the mask is between 20% and 80%
  const clip = 20 + fragmentStar.value * 100 * 0.6;
  return `clip-path: polygon(0 0, ${clip}% 0, ${clip}% 100%, 0% 100%)`;
});
</script>
<template>
  <div
    class="inline-flex gap-0.5 text-yellow"
    role="img"
    :aria-label="t('reviews.star_rating_aria_label', { rating })"
  >
    <div v-for="index in fullStars" :key="index" class="size-5">
      <IconStarRatingSolid class="size-5" aria-hidden="true" />
    </div>
    <div v-if="fragmentStar > 0" class="relative size-5" aria-hidden="true">
      <IconStarRatingOutlined class="absolute size-full" aria-hidden="true" />
      <div class="absolute size-full" :style="mask">
        <IconStarRatingSolid class="size-5" aria-hidden="true" />
      </div>
    </div>

    <div v-for="index in outlinedStars" :key="index" class="size-5">
      <IconStarRatingOutlined class="size-5" aria-hidden="true" />
    </div>
  </div>
</template>
